const paymentOptions = [
    { label: 'Credit / Debit Card' , value: 'card' },
    { label: 'Buy Now Pay Later', value: 'payLater' },
    { label: 'HSA/FSA Card', value: 'hsa/fsa' },
  ]
  
  export default paymentOptions;